module.exports = __webpack_public_path__ + "static/media/2.16a2834e.png";